// @flow
import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';
import { Record, Map as ImmutableMap } from 'immutable';
import type { RecordFactory, RecordOf } from 'immutable';

type FeatureFlagsStoreProps = QcsSyncResourceStoreProps & {
  featureFlags: ImmutableMap<string, any>,
};
export type FeatureFlagsStore = RecordOf<FeatureFlagsStoreProps>;
export const mkFeatureFlagsStore: RecordFactory<FeatureFlagsStoreProps> =
  Record({
    featureFlags: ImmutableMap(),
    resourceName: 'FEATURE_FLAGS',
    loadPending: true,
    isLoading: false,
    error: undefined,
  });

export const REDUCER_KEY = 'featureFlagsStore';
